import { readConsent, CONSENT_GRANTED } from "./src/components/consent/consent-cookie"

// Wrap the whole app in the cookie-consent provider (banner + gated trackers).
// Shared with gatsby-ssr.js.
export { wrapRootElement } from "./gatsby-shared"

export const onRouteUpdate = ({ location }) => {
  if (!location.hash) {
    window.scrollTo(0, 0);
  }

  // GTM is now injected client-side by <TrackerScripts> (behind consent) instead
  // of by gatsby-plugin-google-tagmanager, so the plugin's automatic SPA
  // route-change event no longer fires. Replicate it here — but only once the
  // visitor has consented and GTM is actually loaded.
  if (typeof window !== "undefined" && readConsent() === CONSENT_GRANTED) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: "gatsby-route-change" });
  }
};
